import { graphql } from "../../generated"

export const TRANSFER_SUB_TO_USER_QRY = graphql(`
    query TransferToUserModals(
        $usersFirst: Int
        $subjectFilter: SubjectFilter
        $subscriptionInput: AlertSubscriptionsForIDsInput!
    ) {
        users(first: $usersFirst, filter: $subjectFilter) {
            nodes {
                ...SubjectFragForTransferSubToUser
            }
        }
        subscriptionsForIDs(input: $subscriptionInput) {
            subscriptions {
                ...SubscriptionFragForTransferSubToUser
            }
        }
    }
`)
